<template>
  <v-content>
    <v-container>
      <v-layout text-xs-center wrap>
        <v-flex xs12>
          <h3>Admin Page</h3>
          <form class="mb-3 text-center">
            <v-text-field
              v-model="name"
              :error-messages="nameErrors"
              :counter="50"
              label="Drug Name"
              required
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <v-select
              v-model="month"
              :items="months"
              item-value="value"
              item-text="name"
              :error-messages="monthsErrors"
              label="Month"
              required
              @change="$v.months.$touch()"
              @blur="$v.months.$touch()"
            ></v-select>
            <v-select
              v-model="year"
              :items="years"
              :error-messages="yearsErrors"
              label="Year"
              required
              @change="$v.years.$touch()"
              @blur="$v.years.$touch()"
            ></v-select>
            <v-select
              v-model="projectDesignation"
              :items="projectDesignations"
              :error-messages="projectDesignationsErrors"
              label="Project Designation"
              required
              @change="$v.projectDesignations.$touch()"
              @blur="$v.projectDesignations.$touch()"
            ></v-select>
            <v-select
              v-model="signatureRequired"
              :items="signatureRequiredOptions"
              :error-messages="signatureRequiredErrors"
              label="Signature Required"
              required
              @change="$v.signatureRequiredOptions.$touch()"
              @blur="$v.signatureRequiredOptions.$touch()"
            ></v-select>

            <v-btn class="success" @click="submit">submit</v-btn>
            <v-btn class="error ml-2" @click="clear">clear</v-btn>
          </form>

          <h3>Audit Events</h3>
          <v-data-table
            :headers="auditEventsHeaders"
            :items="auditEvents"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.managerID="{ item }">
              <v-btn class="primary" @click="openEditor(item.managerID)"
                >Show</v-btn
              >
            </template>
            <template v-slot:item.auditDate="{ item }">
              <td class="text-xs-left">
                {{ moment(item.auditDate).format("MMMM YYYY") }}
              </td>
            </template>

            <template v-slot:item.sharingID="{ item }">
              <v-btn class="primary" @click="openSharingLink(item.sharingID)"
                >Share</v-btn
              >
            </template>
          </v-data-table>

          <div class="pt-3">
            <h3>Site Statistics</h3>
            <v-row no-gutters>
              <v-col cols="12" sm="6">
                <Health />
              </v-col>
              <v-col cols="12" sm="6">
                <v-container class="text-center" justify-center>
                  <v-btn to="/admin/loginStats">Login Stats</v-btn>
                </v-container>
              </v-col>
            </v-row>
          </div>

          <h3>Completed Audit Events</h3>
          <v-data-table
            :headers="auditEventsHeaders"
            :items="completedAuditEvents"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.managerID="{ item }">
              <v-btn class="primary" @click="openEditor(item.managerID)"
                >Show</v-btn
              >
            </template>
            <template v-slot:item.auditDate="{ item }">
              <td class="text-xs-left">
                {{ moment(item.auditDate).format("MMMM YYYY") }}
              </td>
            </template>

            <template v-slot:item.sharingID="{ item }">
              <v-btn class="primary" @click="openSharingLink(item.sharingID)"
                >Share</v-btn
              >
            </template>
          </v-data-table>

          <v-dialog v-model="openSharingLinkDialog" persistent max-width="450">
            <v-card class="text-center" justify-center>
              <v-card-title class="headline">Sharing Info</v-card-title>
              <v-card-text>
                <v-btn @click="openPermanentLink()">Permanent Link</v-btn>
              </v-card-text>
              <v-card-text> Generate Expiring Link </v-card-text>
              <v-card-text>
                <v-date-picker v-model="temporaryLinkDate"></v-date-picker>
                <v-btn
                  @click="generateTemporaryLink()"
                  :disabled="!temporaryLinkDate"
                  :loading="generatingTempLink"
                  >Generate Temporary Link</v-btn
                >
              </v-card-text>

              <v-card-text> Existing Expiring Links </v-card-text>

              <v-data-table
                :headers="sessionTokenHeaders"
                :items="sessionTokens"
                class="elevation-1"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ props.header.text }}</span>
                    </template>
                    <span>{{ props.header.text }}</span>
                  </v-tooltip>
                </template>

                <template v-slot:item.expDate="{ item }">
                  <td class="text-xs-left">
                    {{ moment(item.expDate).format("MM/DD/YYYY") }}
                  </td>
                </template>

                <template v-slot:item.token="{ item }">
                  <v-btn
                    class="primary"
                    @click="openTempSharingLink(item.token)"
                    >Open</v-btn
                  >
                </template>

                <template v-slot:item.id="{ item }">
                  <v-btn class="error" @click="deleteTempSharingLink(item.id)"
                    >Delete</v-btn
                  >
                </template>
              </v-data-table>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeSharingLink()"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable no-console */
import axios from "axios";
import { get } from "lodash";
import Health from "./Health.vue";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(50) },
    months: { required },
    years: { required },
    projectDesignations: { required },
    signatureRequiredOptions: { required },
  },
  name: "Admin",
  components: {
    Health,
  },
  data: () => ({
    token: null,
    auditEventsHeaders: [
      { text: "Show", value: "managerID", sortable: false },
      { text: "Audit Date", value: "auditDate", sortable: false },
      { text: "Drug Name", value: "drugName", sortable: false },
      {
        text: "Project Designation",
        value: "projectDesignation",
        sortable: false,
      },
      { text: "Auditor ID", value: "auditorID", sortable: false },
      { text: "Sharing Link", value: "sharingID", sortable: false },
      { text: "Uploads Allowed", value: "auditorActive", sortable: false },
      { text: "Sharing Allowed", value: "eventActive", sortable: false },
      {
        text: "Signature Required",
        value: "signatureRequired",
        sortable: false,
      },
    ],
    allPhotosHeaders: [
      { text: "Date Taken", value: "date", sortable: false },
      { text: "Preview", value: "preview", sortable: false },
    ],
    sessionTokenHeaders: [
      { text: "Expiration Date", value: "expDate", sortable: false },
      { text: "Link", value: "token", sortable: false },
      { text: "Delete", value: "id", sortable: false },
    ],
    auditEvents: [],
    photos: [],
    name: "",
    month: null,
    year: null,
    projectDesignation: null,
    signatureRequired: null,
    months: [
      {
        name: "January",
        value: 0,
      },
      {
        name: "February",
        value: 1,
      },
      {
        name: "March",
        value: 2,
      },
      {
        name: "April",
        value: 3,
      },
      {
        name: "May",
        value: 4,
      },
      {
        name: "June",
        value: 5,
      },
      {
        name: "July",
        value: 6,
      },
      {
        name: "August",
        value: 7,
      },
      {
        name: "September",
        value: 8,
      },
      {
        name: "October",
        value: 9,
      },
      {
        name: "November",
        value: 10,
      },
      {
        name: "December",
        value: 11,
      },
    ],
    years: [
      new Date().getFullYear(),
      new Date().getFullYear() + 1,
      new Date().getFullYear() + 2,
      new Date().getFullYear() + 3,
      new Date().getFullYear() + 4,
      new Date().getFullYear() + 5,
      new Date().getFullYear() + 6,
    ],
    projectDesignations: ["Campaign", "Network"],
    signatureRequiredOptions: [true, false],
    previewPhotoSrc: null,
    previewPhotoID: null,
    previewPhotoKey: null,
    previewPhotoFailed: null,
    photoPreviewDialog: false,
    photoPreviewDialogCheck: false,
    completedAuditEvents: [],
    sharingLinkId: null,
    openSharingLinkDialog: false,
    temporaryLinkDate: null,
    sessionTokens: [],
    generatingTempLink: false,
  }),
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.maxLength &&
        errors.push("Name must be at most 50 characters long");
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    monthsErrors() {
      const errors = [];
      if (!this.$v.months.$dirty) return errors;
      !this.$v.months.required && errors.push("Item is required");
      return errors;
    },
    yearsErrors() {
      const errors = [];
      if (!this.$v.years.$dirty) return errors;
      !this.$v.years.required && errors.push("Item is required");
      return errors;
    },
    projectDesignationsErrors() {
      const errors = [];
      if (!this.$v.projectDesignations.$dirty) return errors;
      !this.$v.projectDesignations.required && errors.push("Item is required");
      return errors;
    },
    signatureRequiredErrors() {
      const errors = [];
      if (!this.$v.signatureRequiredOptions.$dirty) return errors;
      !this.$v.signatureRequiredOptions.required &&
        errors.push("Item is required");
      return errors;
    },
  },
  mounted() {
    for (var i = 0, len = localStorage.length; i < len; ++i) {
      if (localStorage.key(i).indexOf("adal.access.token.key") !== -1) {
        this.token = localStorage.getItem(localStorage.key(i));
      }
    }
    this.getAllAuditEvents();
    this.getAllPhotos();
    this.getAllCompletedAudits();
  },
  methods: {
    submit() {
      this.$v.$touch();
      this.addAuditEvent();
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.month = null;
      this.year = null;
      this.projectDesignation = null;
    },
    getAllAuditEvents() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllAuditEvents`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.auditEvents = response.data;
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
    addAuditEvent() {
      // Always set to the fifth of the month
      let date = new Date(this.year, this.month, 5);

      let config = {
        url: `${this.getBaseUrl}/admin/auditEvent`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
        data: {
          auditDate: date,
          drugName: this.name,
          projectDesignation: this.projectDesignation,
          signatureRequired: this.signatureRequired,
        },
      };

      axios(config)
        .then((response) => {
          if (response.status === 201) {
            alert("Added Event!");
            this.getAllAuditEvents();
            this.clear();
          } else {
            alert("Error Adding Event!");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Error Adding Event!");
        });
    },
    openPermanentLink() {
      let link = `/photos/${this.sharingLinkId}`;
      this.$router.push(link);
    },
    openTempSharingLink(token) {
      let link = `/photos/${token}`;
      this.$router.push(link);
    },
    async deleteTempSharingLink(id) {
      let config = {
        url: `${this.getBaseUrl}/admin/deleteTokenForSharingByTokenID/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };

      try {
        await axios(config);
      } catch (error) {
        console.log("Error deleting session by ID");
        console.log(error.message);
        alert("Error deleting session by ID");
      }

      this.closeSharingLink();
    },
    async openSharingLink(id) {
      let config = {
        url: `${this.getBaseUrl}/admin/getTokensForSharingBySharingID/${id}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };

      try {
        const response = await axios(config);
        this.sessionTokens = get(response, "data", []);
      } catch (error) {
        console.log("Error getting sessions by sharing ID");
        console.log(error.message);
        alert("Error getting sessions by sharing ID");
      }

      this.sharingLinkId = id;
      this.openSharingLinkDialog = true;
      this.temporaryLinkDate = null;
    },
    closeSharingLink() {
      this.sharingLinkId = null;
      this.openSharingLinkDialog = false;
      this.temporaryLinkDate = null;
    },
    async generateTemporaryLink() {
      this.generatingTempLink = true;
      let config = {
        url: `${this.getBaseUrl}/admin/generateTokenForSharing`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
        data: {
          sharingId: this.sharingLinkId,
          expDate: this.temporaryLinkDate,
        },
      };

      try {
        await axios(config);
        this.generatingTempLink = false;
        this.openSharingLink(this.sharingLinkId);
      } catch (error) {
        console.log("Error generating temporary token");
        console.log(error.message);
        alert("Error generating temporary token");
      }
    },
    openEditor(id) {
      let link = `/admin/${id}`;
      this.$router.push(link);
    },
    getAllPhotos() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllPhotos`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.photos = response.data;
          } else {
            alert("Error Getting All Photos!");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Error Getting All Photos!");
        });
    },
    previewPhoto(photo, id, photoKey, failed) {
      this.previewPhotoSrc = photo;
      this.previewPhotoID = id;
      this.previewPhotoKey = photoKey;
      this.previewPhotoFailed = failed;
      this.photoPreviewDialog = true;
    },
    deletePhotoPrompt() {
      this.photoPreviewDialogCheck = true;
    },
    doNOTdeletePhoto() {
      this.resetDeletePhoto();
    },
    deletePhoto() {
      let config = {
        url: `${this.getBaseUrl}/admin/deletePhoto`,
        method: "POST",
        data: {
          id: this.previewPhotoID,
          photoKey: this.previewPhotoKey,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.getAllPhotos();
            this.resetDeletePhoto();
          } else {
            alert("Error deleting Photo!");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Error deleting Photo!");
        });
    },
    resetDeletePhoto() {
      this.previewPhotoSrc = null;
      this.previewPhotoID = null;
      this.previewPhotoKey = null;
      this.previewPhotoFailed = null;
      this.photoPreviewDialog = false;
      this.photoPreviewDialogCheck = false;
    },
    getAllCompletedAudits() {
      let config = {
        url: `${this.getBaseUrl}/admin/getAllCompletedAuditEvents`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      };
      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.completedAuditEvents = response.data;
          } else {
            // todo Improve Error Handling
          }
        })
        .catch((err) => {
          console.log(err);
          // todo Improve Error Handling
        });
    },
  },
};
</script>

<style scoped></style>
